import httpClient from "Api/httpClient";

const END_POINT = "/projects";

const getProjects = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getProject = (project_id) => {
    if (!project_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + project_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printProject = (project_id) => {
    if (!project_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?project_id=" + project_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createProjects = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateProjects = (payload, project_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + project_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteProjects = (project_id) => {
    const DELETE_END_POINT = END_POINT + "/" + project_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getProjects, getProject, printProject, createProjects, updateProjects, deleteProjects };
